import React from 'react';
import {PartnersUIProvider} from '../components/PartnersUIContext';
import {PartnersLoadingDialog} from '../components/partners-loading-dialog/PartnersLoadingDialog';
import {PartnersCard} from './PartnersCard';

export function PartnersPage() {
  return (
    <PartnersUIProvider>
      <PartnersLoadingDialog />
      <PartnersCard/>
    </PartnersUIProvider>
  );
}
